import { trustStats } from "@/mocks/testimonials";
import { Link } from "react-router-dom";

export default function TrustStats() {
  return (
    <section className="px-4 md:px-8 py-12 sm:py-16 md:py-24 bg-background-100">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-7">
          <div className="inline-flex items-center gap-2 mb-5 px-3 py-1 rounded-full bg-background-50 border border-background-200 text-[11px] uppercase tracking-[0.18em] text-foreground-700">
            <span className="w-1.5 h-1.5 rounded-full bg-accent-500"></span>
            Independent · Local · Qualified
          </div>
          <h2 className="text-2xl sm:text-3xl md:text-5xl font-heading font-semibold tracking-tight text-foreground-950 leading-[1.05] max-w-2xl">
            One skilled electrician<br className="hidden md:block" />
            <em className="not-italic text-accent-600">who actually turns up</em> when agreed.
          </h2>
          <p className="mt-5 text-base md:text-lg text-foreground-600 max-w-xl">
            No call centres, no big teams, no surprise fees. Just clean electrical
            work by someone who lives and works in the local area.
          </p>

          <div className="mt-10 grid grid-cols-3 gap-4 border-t border-background-300 pt-8">
            {trustStats.map((s, i) => (
              <div
                key={s.label}
                className={`pr-3 ${i < 2 ? "border-r border-background-300" : ""}`}
              >
                <div className="text-2xl sm:text-3xl md:text-5xl font-heading font-semibold text-accent-600 tracking-tight">
                  {s.value}
                </div>
                <div className="mt-2 text-xs md:text-sm text-foreground-600 leading-snug">
                  {s.label}
                </div>
              </div>
            ))}
          </div>

          <div className="mt-8 flex flex-wrap gap-2">
            {[
              "Fully qualified",
              "Public liability insured",
              "Part P registered",
              "Clear pricing",
              "Tidy workmanship",
            ].map((t) => (
              <span
                key={t}
                className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-background-50 border border-background-200 text-xs text-foreground-800"
              >
                <i className="ri-check-line text-accent-600"></i>
                {t}
              </span>
            ))}
          </div>
        </div>

        <div className="lg:col-span-5">
          <div className="relative rounded-2xl overflow-hidden bg-background-200">
            <img
              src="https://readdy.ai/api/search-image?query=Portrait%20of%20an%20independent%20UK%20electrician%20in%20navy%20workwear%20holding%20tools%20standing%20in%20a%20London%20terraced%20home%20hallway%20with%20warm%20natural%20window%20light%2C%20confident%20friendly%20expression%2C%20realistic%20editorial%20portrait%20photography%2C%20soft%20shadows%2C%20detailed%20texture&width=720&height=880&seq=trust-portrait-01&orientation=portrait"
              alt="Portrait of the local electrician"
              loading="lazy" decoding="async"
              className="w-full aspect-[4/5] object-cover object-top"
            />
            <div className="absolute bottom-4 left-4 right-4 p-4 rounded-xl bg-background-50/95 backdrop-blur-md">
              <div className="flex items-center gap-3">
                <div className="w-11 h-11 flex items-center justify-center rounded-full bg-accent-500 text-primary-950">
                  <i className="ri-user-3-line text-lg"></i>
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-950">James Wallace</p>
                  <p className="text-xs text-foreground-600">Independent electrician · Islington N1</p>
                </div>
                <Link
                  to="/about"
                  aria-label="Read about James"
                  className="ml-auto w-9 h-9 flex items-center justify-center rounded-full bg-primary-950 text-background-50 hover:bg-primary-900 transition-colors cursor-pointer"
                >
                  <i className="ri-arrow-right-up-line"></i>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}